module.exports = __webpack_public_path__ + "static/media/food-icon-active.e1ecf19c.svg";